import React from 'react';

import ShipmentsAdvancedSearchContainer from './redux-container';
import { AdvancedSearchShipmentContextProvider } from './context';
import { PagingContextProviderContainer } from '../../contexts/paging-context/container';
import Global from '../../store/global-selectors';

const OrdersAdvancedSearch = () => {
  return (
    <PagingContextProviderContainer pageSelector={Global.selectShipmentsGridPage} pageSizeSelector={Global.selectShipmentsGridPageSize}>
      <AdvancedSearchShipmentContextProvider>
        <ShipmentsAdvancedSearchContainer />
      </AdvancedSearchShipmentContextProvider>
    </PagingContextProviderContainer>
  );
};

export default OrdersAdvancedSearch;
